import React from 'react'
import useFetchList from '../../../elements/Hooks/useFetchList'
import { ReportsApi } from '../../../api/Corporates/Reports'
import { moneyColumn, numVal, strVal } from '../../../modules/Utils'
import { StyledStrong } from '../../../components/Common/Amount'
import { Alert, Row, Table } from 'antd'
import RefreshButton from '../../../elements/Buttons/RefreshButton'
import { Link } from 'react-router-dom'
import OrganisationsSelect from '../../../elements/Select/Organistaions'

Sales.propTypes = {}

function Sales (props) {
  const [company, setCompany] = React.useState([])

  const { list, fetch, fetching } = useFetchList(() => ReportsApi.sales(company), [company], undefined, undefined, {
    data: [],
    periods: [],
  })
  const columns = [
    {
      title: <strong>Name</strong>,
      dataIndex: 'name',
      width: 325,
      fixed: 'left',
      style: {
        textAlign: 'left',
        // marginLeft: '0.5rem',
      },
      render: (value, original) => {
        if (strVal(original, '_id').includes('sales/'))
          return (
            <Link
              target={'_blank'}
              to={{
                pathname: `/clients/orders/${original._id.replace('sales/', '')}/update`,
              }}>
              <span style={{ marginLeft: '1rem' }}>{value}</span>
            </Link>
          )
        if (strVal(original, '_id').includes('salesContracts/'))
          return (
            <Link
              target={'_blank'}
              to={{
                pathname: `/clients/${original.owner.replace('members/', '')}/contracts/${original._id.replace(
                  'salesContracts/',
                  '',
                )}/view`,
              }}>
              <span style={{ marginLeft: '1rem' }}>{value}</span>
            </Link>
          )
        return original.style ? (
          <strong
            style={{
              marginLeft: original.isHeader && '-1.5rem',
              fontSize: original.isHeader ? '1.2rem' : '1rem',
              textTransform: 'uppercase',
              textAlign: 'left',
            }}>
            {value}
          </strong>
        ) : (
          <span style={{ marginLeft: '1rem' }}>{value}</span>
        )
      },
    },
    ...list.periods.map((r) => ({
      title: <strong>{r.name}</strong>,
      dataIndex: r.name,
      width: 135,
      render: (value, original) =>
        value && (
          <span
            style={{
              fontSize: '0.9rem',
              textTransform: 'uppercase',
              textAlign: 'left',
              fontWeight: original.style && 'bold',
            }}>
            {value < 0
              ? `(${moneyColumn(numVal({ value: value * -1 }, 'value'))})`
              : moneyColumn(numVal({ value }, 'value'))}
          </span>
        ),
      headerStyle: {
        textAlign: 'right',
      },
      style: {
        textAlign: 'right',
      },
    })),
  ]
  return (
    <div style={{ overflowY: 'scroll' }}>
      <Alert
        style={{ marginBottom: 20 }}
        message="The Report Is Very Wide, Note That You Can Scroll Horizontally"
        type="info"
        showIcon
      />

      <Table
        title={() => (
          <Row>
            <StyledStrong>Consolidated Sales Report (USD)</StyledStrong>
            <RefreshButton onClick={fetch}/>
            <OrganisationsSelect
              value={company}
              onChange={(value) => setCompany(value)}
              mode="multiple"
              style={{ float: 'right', marginRight: '1rem', width: '50rem' }}
            />
          </Row>
        )}
        key={new Date().getTime().toString()}
        pagination={{ pageSize: 50 }}
        loading={fetching}
        columns={columns}
        dataSource={list.data}
        rowKey={'name'}
      />
    </div>
  )
}

export default Sales
